import Utils from '../../../util';
import { v4 as uuid } from 'uuid';
import { AnessaListItem } from '../../anessa-list-item.interface';
import { ProjectInputItem } from '../../data-structures/project/project-input-item.model';


export interface SensitivityItemInterface {
  id: string;
  uuid: string | null;
  nameElements?: string[];
  value: number | null;
  unit: string;
  path: string[];
  category?: string;
  min: number | null;
  max: number | null;
  selected: boolean;
}

export class SensitivityItem implements AnessaListItem {
  id: string;
  uuid: string | null = null;
  nameElements?: string[];
  value: number | null = null;
  unit: string;
  path: string[];
  category?: string;
  min: number | null = null;
  max: number | null = null;
  // this is for the GUI (mat-select)
  selected: boolean;

  constructor(param: SensitivityItemInterface = {
    id: '',
    uuid: null,
    nameElements: [],
    value: null,
    unit: '',
    path: [],
    category: '',
    min: null,
    max: null,
    selected: false
  }) {
    this.id = param.id;
    this.uuid = param.uuid ? param.uuid : uuid();
    this.nameElements = param.nameElements;
    if (Utils.isNumeric(param.value)) this.value = param.value;
    this.unit = param.unit;
    this.path = param.path;
    this.category = param.category;
    if (Utils.isNumeric(param.min)) this.min = param.min;
    if (Utils.isNumeric(param.max)) this.max = param.max;
    Utils.isBoolean(param.selected) ? this.selected = param.selected : this.selected = false;
  }

  static arrayDeepCopy(items: SensitivityItem[]) {
    const copy: SensitivityItem[] = [];
    if (items && items.length) {
      for (const item of items) {
        copy.push(new SensitivityItem(item));
      }
    }
    return copy;
  }

  /**
   * Creates a new SensitivityItem with data provided from the ProjectInputItem param.
   * @param projectInput is a ProjectInputItem that contains data that will be mapped to the new SensitivityItem.
   */
  static fromProjectInput(projectInput: ProjectInputItem): SensitivityItem {
    const sensItem = new SensitivityItem();
    sensItem.id = projectInput.id;
    sensItem.nameElements = projectInput.nameElements;
    sensItem.path = projectInput.path;
    sensItem.value = projectInput.value;
    sensItem.unit = projectInput.unit;
    return sensItem;
  }

  setBasicInfo(id: string, nameElements: string[], value?: number, unit: string='', selected: boolean=false, path: string[]=[]) {
    this.id = id;
    this.nameElements = nameElements;
    this.value = value ?? null;
    this.unit = unit;
    this.selected = selected;
    this.path = path;
  }
}
